import type { AppState } from 'admin/src/store';
import { useAppSelector } from './useAppSelector';
import { PermissionLevel } from '../components/CheckAppPermissions';
import type { PermissionKey, SecurityLevel } from 'admin/src/types';

export function hasPermission(app: PermissionKey, requiredLevel: PermissionLevel, appPermissions?: SecurityLevel) {
  if (!appPermissions) return false;
  if (appPermissions.systemAdmin) return true;

  const userLevel = appPermissions[app] ?? PermissionLevel.None;

  return userLevel >= requiredLevel;
}

export function selectUserPermissions(state: AppState) {
  return state.user.employeeInfo?.securityLevelInfo;
}

export function useHasAppPermission(app: PermissionKey, requiredLevel = PermissionLevel.View) {
  const appPermissions = useAppSelector(selectUserPermissions);

  return hasPermission(app, requiredLevel, appPermissions);
}
